export const passwordValidationRegex =
  /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^?!():])(?=\S+$).{8,}$/;
